import { Card, CardHeader, CardContent, Avatar, Typography } from '@material-ui/core'
import ItemBanner from './ItemBanner'
import Moment from 'moment'

import './styles.css'

const Item = ({announcement}) => {
    const formatDate = (date) => {
        return Moment(date).format('MMMM D, YYYY hh:mm a')
    }

    return (
        <Card style={{marginBottom: '10px'}}>
            <CardHeader
                avatar={<Avatar alt={announcement.created_by} src='/unknow/path'/>}
                title={
                    <Typography variant='body1' component='h2' style={{fontWeight: 'bold'}}>{announcement.created_by}</Typography>
                }
                subheader={
                    <Typography varitn='body2' component='p'>{formatDate(announcement.created_at)}</Typography>
                }
            />
            <CardContent>
                { announcement.banner !== '' && <ItemBanner src={announcement.banner}/> }
                <Typography className="announcement-title" variant='h6' component='h2'>{announcement.title}</Typography>
                <Typography dangerouslySetInnerHTML={{__html: announcement.body}} />
            </CardContent>
        </Card>
    )
}

export default Item;